import React from 'react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from './ui/card';

const PracticeAreas = ({ areas }) => {
  return (
    <section id="practice" className="section-container section-alt">
      <div className="content-wrapper">
        <h2 className="section-title">Напрямки діяльності</h2>
        <div className="practice-grid">
          {areas.map((area) => (
            <Card key={area.id} className="practice-card">
              <CardHeader>
                <CardTitle className="practice-card-title">{area.title}</CardTitle>
              </CardHeader>
              <CardContent>
                <CardDescription className="practice-card-description">
                  {area.description}
                </CardDescription>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PracticeAreas;
